import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import {
  Body2,
  body2,
  body2Bold,
  colors,
  duration,
  easing,
  fontWeights,
  link2,
  spacing,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { ACTIVE_CLASS_NAME, MOBILE_MENU_MAX_BREAKPOINT } from '../../constants';

export const Description = styled(Body2)`
  grid-area: description;
  color: ${colors.textSecondary};

  .${ACTIVE_CLASS_NAME} > & {
    color: ${colors.purple90};
  }
`;

export const IconContainer = styled.span`
  grid-area: icon;
  display: flex;
  align-self: center;
  margin-right: ${spacing.threeQuarter};
  color: ${colors.grey50};

  .${ACTIVE_CLASS_NAME} > & {
    color: ${colors.purple50};
  }
`;

export const LinkNav = styled.div`
  grid-area: linkNav;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${spacing.threeQuarter} ${spacing.half};
  margin-top: ${spacing.half};
  @media screen and (max-width: ${MOBILE_MENU_MAX_BREAKPOINT}) {
    gap: ${pxToRem(20)};
    grid-template-columns: 1fr;
    margin-bottom: ${spacing.threeQuarter};
    margin-top: ${spacing.threeQuarter};
  }
`;

const LayoutStyles = css`
  display: grid;
  grid-template-areas: 'icon text' '. description' '. linkNav';
  grid-template-columns: auto 1fr;
  padding: ${spacing.half} ${spacing.threeQuarter};
  border-radius: ${spacing.threeEights};
  transition: all ${duration.short} ${easing.standard};
`;

const LinkStyles = css`
  &:hover {
    background-color: ${colors.grey10};
    text-decoration: none;
  }

  &.${ACTIVE_CLASS_NAME} {
    color: ${colors.purple100};
    background-color: ${colors.purple10};
    text-decoration: none;
  }

  &:focus {
    outline-color: ${colors.green50};
  }
`;

export const MenuLink = styled(NavLink)`
  ${LayoutStyles}
  ${LinkStyles}
`;

export const SubLink = styled(NavLink)`
  ${link2}
  text-decoration-color: transparent;

  &.${ACTIVE_CLASS_NAME} {
    color: ${colors.textInteractiveHover};
    font-weight: ${fontWeights.semiBold};
    text-decoration-color: ${colors.borderInteractiveStrong};
  }
`;

export const Subsection = styled.div`
  ${LayoutStyles}
`;

export const Title = styled.span<{ isHeading: boolean }>`
  ${({ isHeading }) => (isHeading ? body2Bold : body2)};
  grid-area: text;
  display: flex;
  align-self: center;
  margin-bottom: 0;

  .${ACTIVE_CLASS_NAME} > & {
    color: ${colors.purple100};
  }
`;
